import React from 'react'
import './Home.css';
import './Mobilehome.css';
import Menubar from '../components/Menubar';
import Footer from '../components/Footer';
import Webillustration from '../assets/illus.svg';
import Arrow from '../assets/arrow.svg';
import Htmlicon from '../assets/html icon.svg';
import Cssicon from '../assets/css icon.svg';
import Javascicon from '../assets/javascript icon.svg';
import Webicon from '../assets/website development icon.svg';
import Fronticon from '../assets/frontend development icon.svg';
import Env from '../assets/envdemo.png';

import { Link } from 'react-router-dom';

const linkStyle = {
  textDecoration: "none",
};

function Home() {
  return (
    <div className='App'>
      <div className='men'>
        <Menubar />
      </div>
      <div className='homehero'>
        <h1>Platform & Tool To Learn Web Development</h1>
        <p>Learn & make simple website features to complex digital web products</p>
      </div>

      <div className='goal'>
        <h1>What's Your Goal</h1>
        <div className='goalpost'>
          <h2>Explore web development</h2>
          <p>In the begining, lessons are easy. As your learning progresses so does the difficulty level. </p>
          <div className='chapters'>
            <div className='chapternumber'>
              <img src={Htmlicon} />
              <h3>HTML basics</h3>
              <p>If you are new to web development begin your coding journey with this markup language.</p>
              <Link to = "/html" style={linkStyle}>Start learning<img src={Arrow}/></Link>
            </div>
            <div className='chapternumber' id='cssicon'>
              <img src={Cssicon} />
              <h3>Css basics</h3>
              <p>You can make visually appealing websites using CSS. You should learn CSS after HTML.</p>
              <Link to = "/css" style={linkStyle}>Start learning<img src={Arrow}/></Link>
            </div>
            <div className='chapternumber'>
              <img src={Javascicon} />
              <h3>Javascript basics</h3>
              <p>Javascript adds functionality to websites. It is also a very intergral part of building web apps.</p>
              <Link to = "/js" style={linkStyle}>Start learning<img src={Arrow}/></Link>
            </div>
          </div>
        </div>


        <div className='goalpost'>
        <h2>Gain a professional skill</h2>
          <p>You can choose a structured path to develop a desired skill. </p>
          <div className='chapters'>
            <div className='chapternumber' id='chapternumber2'>
              <img src={Webicon} />
              <h3>Website Development</h3>
              <p>Coming Soon</p>
            </div>
            <div className='chapternumber'>
              <img src={Fronticon} />
              <h3>Front-end Development</h3>
              <p>Coming Soon</p>
            </div>
          </div>  
        </div>

        <div className='illustration'>
          <img src={Webillustration} alt='website illustration' />
        </div>

      </div>

      <div className='subjects'>
        <h1>Languages, Libraries, Tools, Frameworks & Much More . . .</h1>
        <p>Currently, only tutorials on basics of web languages are available. Our team is working tirelessly for more tutorials. Stay tuned. We will keep you updated.</p>
        <div className='subjectgrid'>
          <div className='griditem'>
          <h3>HTML</h3>
          </div>
          <div className='griditem'>
          <h3>CSS</h3>
          </div>
          <div className='griditem'>
          <h3>Javascript</h3>
          </div>
          <div className='griditem'>
          <h3>React</h3>
          </div>
        </div>
      </div>
      
      <div className='learncontainer'>
      <div className='learningenvironement'>
        <h1>Learning Environment</h1>
        <div className='environmentgrid'>
          <div className='col'>
            <h2>1</h2>
            <h3>No more tutorial hell</h3>
            <p>Our interactive environment enables you to start writing code from the first lesson.</p>
          </div>
          <div className='col'>
            <h2>2</h2>
            <h3>Easy to use interface</h3>
            <p>Choose your goal. Select a lesson. Read lesson slides and code along.</p>
          </div>
          <div className='col'>
            <h2>3</h2>
            <h3>Short hands on lessons</h3>
            <p>Each lesson is a blend of theory and hands on practice.</p>
          </div>
        </div>
        <div className='envimg'>
          <img src={Env} />
        </div>
      </div>
      </div>

      <div className='faq'>
        <h1>Frequently Asked Questions</h1>
        <div className='faqgrid'>
          <div className='faqcol'>
            <p>Q. Is this platform Free?</p>
            <p>A. Yes, this platform is free for a limited time.</p>
          </div>
          <div className='faqcol'>
            <p>Q. When mentored learning will be available?</p>
            <p>A. Soon.</p>
          </div>
          <div className='faqcol'>
            <p>Q. How frequently do you add new courses?</p>
            <p>A. Typically 15 days to 30 days.</p>
          </div>
          <div className='faqcol'>
            <p>Q. I have more questions where to ask?</p>
            <p>A. Email us at.</p>
          </div>
        </div>
      </div>

      <div className='cta'>
        <h1>Start For Free</h1>
        <p>Joint today to get access to 125+ lessons. Learn something new everyday. Be a pro.</p>
        <button>Login</button>
      </div>

      <Footer />

    </div>
  );
}

export default Home;
